const POST_BV_FEEDBACK = 'POST_BV_FEEDBACK'

export default POST_BV_FEEDBACK
